"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COUNTRY = exports.DEFAULT_CURRENCY_LOCALE = exports.DEFAULT_CURRENCY_CODE = void 0;
exports.DEFAULT_CURRENCY_CODE = 'EUR';
exports.DEFAULT_CURRENCY_LOCALE = 'en-us';
exports.DEFAULT_COUNTRY = { name: 'ALL', code: 'ALL' };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFNVSxRQUFBLHFCQUFxQixHQUFrQixLQUFLLENBQUM7QUFDN0MsUUFBQSx1QkFBdUIsR0FBRyxPQUFPLENBQUM7QUFFbEMsUUFBQSxlQUFlLEdBQWEsRUFBRSxJQUFJLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsQ0FBQyJ9